import Home from './components/home'

import './App.css';

function App() {
  return (
    <>
    <Home />
    </>
);
}

export default App;
